/* @flow */
import BoxHeader from 'components/BoxHeader.jsx';
import Buttons from 'components/Buttons.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import React from 'react';
import Relationship from 'entities/Relationship';
import StartChatButton from 'user/components/StartChatButton.jsx';
import StatusLabel from 'components/StatusLabel.jsx';
import Subscriber from 'entities/Subscriber';
import Text from 'components/Text.jsx';
import GroupMembersTabUserActions from 'user/components/GroupMembersTabUserActions.jsx';

class RelationshipViewHeader extends React.Component {
  static propTypes = {
    relationship: React.PropTypes.instanceOf(Relationship).isRequired,
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
    groupToAdmin: React.PropTypes.instanceOf(Group),
    groupMember: React.PropTypes.instanceOf(GroupMembership),
    onRequestHide: React.PropTypes.func,
  };

  renderHeaderAux = () => {
    const { relationship, subscriber, groupToAdmin, groupMember } = this.props;
    return (
      <Buttons>
        {relationship.isEligibleForChat() &&
          <StartChatButton
            subscriber={subscriber}
            onRequestHide={this.props.onRequestHide}
          />
        }
        <GroupMembersTabUserActions
          groupToAdmin={groupToAdmin}
          groupMembership={groupMember}
          subscriber={subscriber}
          buttonSize="small"
        />
      </Buttons>
    );
  };

  render() {
    const { relationship, subscriber } = this.props;

    let name = (
      <Text truncate>
        {subscriber.getName()}
      </Text>
    );

    let status;
    if (relationship.isPendingForChat()) {
      status = 'Pending';
    } else if (relationship.isUnder13()) {
      status = 'Under 13';
    }

    if (status) {
      name = (
        <div>
          {name}
          <StatusLabel>{status}</StatusLabel>
        </div>
      );
    }

    return (
      <BoxHeader
        className="RelationshipViewHeader"
        title={name}
        aux={this.renderHeaderAux()}
      />
    );
  }
}

export default RelationshipViewHeader;



// WEBPACK FOOTER //
// ./src/user/components/RelationshipViewHeader.jsx